module.exports = __webpack_public_path__ + "img/xltd2.cf1cb1ff.png";